module.exports = __webpack_public_path__ + "img/11.c620ec47.jpg";